import { render, staticRenderFns } from "./FillClaimHead.vue?vue&type=template&id=352ebf49"
import script from "./FillClaimHead.vue?vue&type=script&lang=js"
export * from "./FillClaimHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports